import { useEffect, useRef } from 'react';

export const useAutoFocus = <T extends HTMLElement = HTMLDivElement>(onFocused?: () => void) => {
  const containerRef = useRef<T>(null);

  useEffect(() => {
    const node = containerRef.current;
    if (!node) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          // isIntersecting means the element is now in the viewport
          if (entry.isIntersecting) {
            const target = (node.querySelector('input, select, textarea, [role="button"]') || node) as HTMLElement;

            // Small delay to ensure the browser has finished the paint
            setTimeout(() => {
              target?.focus()
              target.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
                inline: 'nearest'
              })
              onFocused && onFocused()
            }, 50);

            // Stop observing once we've focused the first time
            observer.unobserve(node);
          }
        });
      },
      {
        threshold: 1 // Trigger when 100% of the element is visible
      }
    );

    observer.observe(node);

    return () => observer.disconnect();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [containerRef.current]);

  return containerRef;
};